export interface LoginCredentials {
  username: string;
  password: string;
}

export interface LoginError {
  detail: string;
}

export interface TokenResponse {
  accessToken: string;
  refreshToken: string;
  expiresIn: number | null;
  type: string;
}

export const AUTH_MUTATION_KEYS = {
  TOKEN: ["auth", "token"] as const,
  LOGOUT: ["auth", "logout"] as const,
  GOOGLE: ["auth", "google"] as const,
} as const;

export const AUTH_QUERY_KEYS = {
  USER: ["auth", "user"],
} as const;

export const AUTH_STATUS = {
  LOGGED_IN: "logged-in",
  LOGGED_OUT: "logged-out",
  UNKNOWN: "unknown",
} as const;

export type AuthStatusResponse = (typeof AUTH_STATUS)[keyof typeof AUTH_STATUS];
